import { library } from '@fortawesome/fontawesome-svg-core'
import { faLightbulb, faBars, faTimes } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add( faLightbulb, faBars, faTimes )

export { FontAwesomeIcon }
